var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Dispatcher',{attrs:{"date":_vm.params.date,"asset-type":_vm.params.assetType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }